export default "__VITE_ASSET__C20C1Igk__"